import { render } from "./FirstTasting.vue?vue&type=template&id=06190f9e"
import script from "./FirstTasting.vue?vue&type=script&lang=js"
export * from "./FirstTasting.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__